export default "__VITE_ASSET__DSEIWMp1__"